export default function FilterBar({ activeFilters, onToggle, totalCount, user, displayName, onLogout }) {
  const filters = [
    { key: 'all',         emoji: '🗺️', label: '전체' },
    ...(user ? [{ key: 'following', emoji: '👥', label: '팔로잉' }] : []),
    { key: 'food',        emoji: '🍔', label: '푸드트럭' },
    { key: 'gallery',     emoji: '🎨', label: '갤러리' },
    { key: 'market',      emoji: '🛍️', label: '프리마켓' },
    { key: 'performance', emoji: '🎵', label: '공연' },
    { key: 'popup',       emoji: '🏪', label: '팝업' },
    { key: 'tour',        emoji: '🗺️', label: '관광/행사' },
    { key: 'user',        emoji: '💬', label: '일반' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '10px 12px' }}>
      {user && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
          <span style={{ fontSize: 12, color: '#555' }}>👤 {displayName}</span>
          <button
            type="button"
            onClick={onLogout}
            style={{ fontSize: 11, color: '#999', background: 'none', border: '1px solid #eee', borderRadius: 12, padding: '3px 10px', cursor: 'pointer' }}
          >
            로그아웃
          </button>
        </div>
      )}
      <div style={{ display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 4, scrollbarWidth: 'none' }}>
        {filters.map(f => {
          const isActive = activeFilters.includes(f.key);
          return (
            <button type="button" key={f.key} onClick={() => onToggle(f.key)} style={{
              whiteSpace: 'nowrap', padding: '6px 14px', borderRadius: 20,
              border: isActive ? '2px solid #333' : '1.5px solid #ddd',
              background: isActive ? '#333' : 'white',
              color: isActive ? 'white' : '#333',
              fontSize: 13, cursor: 'pointer',
              fontWeight: isActive ? 500 : 400,
              boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
            }}>
              {f.emoji} {f.label}
            </button>
          );
        })}
      </div>
      <span style={{ fontSize: 12, color: '#555' }}>
        현재 진행 중 <strong>{totalCount}</strong>개 행사
      </span>
    </div>
  );
}